import Vue from 'vue' ;
import {Message} from 'element-ui';
import Router from 'vue-router';

// 路由组件
import error from '@/pages/error';
import mainFrame from '@/pages/mainFrame';
import home from '@/pages/home/index';
import login from '@/pages/login/index';
// 客户管理
import customer from '@/pages/customer/frame'//外层架子；
import customerList from '@/pages/customer/list';
import customerDetail from '@/pages/customer/detail';//品牌商详情改为公用的这个；
// 标签管理
import tag from '@/pages/tag/frame';
import tagIndex from '@/pages/tag/index';
//优惠管理
import discount from '@/pages/discount/frame';
import discountList from '@/pages/discount/list';
import discountAdd from '@/pages/discount/add';
import discountDetail from '@/pages/discount/detail';
//商家管理
import business from '@/pages/business/frame';
import businessList from '@/pages/business/list';
import businessAdd from '@/pages/business/add';
import businessDetail from '@/pages/business/detail';
import businessEdit from '@/pages/business/edit';
//商品管理
import goods from '@/pages/goods/frame';
import goodsList from '@/pages/goods/list';
import goodsAdd from '@/pages/goods/add';
import goodsDetail from '@/pages/goods/detail';
import goodsEdit from '@/pages/goods/edit';

//园区管理
import park from '@/pages/park/frame';
import parkList from '@/pages/park/list';
import parkAdd from '@/pages/park/add';
import parkDetail from '@/pages/park/detail';
import parkEdit from '@/pages/park/edit';


//系统管理
import system from '@/pages/system/frame';//外层架子；
import leftMenuManager from '@/pages/system/leftMenuManager';
import userManager from '@/pages/system/userManager';
import roleManager from '@/pages/system/roleManager';
import functionManager from '@/pages/system/functionManager';
//公共
import editPwd from '@/pages/commonPage/editPwd'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect:'/login',
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{title:'登录'}
    },
    {
      path: '/mainFrame',
      name: 'mainFrame',
      component: mainFrame,
      children:[
        {
          path: '/404',
          name: 'error',
          component: error,
          meta:{title:'404'}
        },
        {
          path: '/home',
          name: 'home',
          component: home,
          meta:{title:'首页',isShowBread:true,matchLeftKey:'/home'}
        },
        {
          path: '/tag/index',
          name: 'tagIndex',
          component: tagIndex,
          meta:{title:'标签管理',isShowBread:true,matchLeftKey:'/tag'}
        },
        {
          path: '/customer',
          name: 'customer',
          component: customer,
          meta:{title:'客户管理'},
          children:[
            {
              path: 'list',
              name: 'customerList',
              component: customerList,
              meta:{title:'客户列表',isShowBread:true,matchLeftKey:'/customer/list'}
            },
            {
              path: 'detail/:userId',
              name: 'customerDetail',
              component: customerDetail,
              meta:{title:'客户详情',isShowBack:true,isShowBread:true,matchLeftKey:'/customer/list'}
            },
          ]
        },
        {
          path: '/discount',
          name: 'discount',
          component: discount,
          meta:{title:'优惠管理'},
          children:[
            {
              path: 'list',
              name: 'discountList',
              component: discountList,
              meta:{title:'优惠列表',isShowBread:true,matchLeftKey:'/discount/list'}
            },
            {
              path: 'detail/:userId',
              name: 'discountDetail',
              component: discountDetail,
              meta:{title:'优惠详情',isShowBack:true,isShowBread:true,matchLeftKey:'/discount/detail'}
            },
            {
              path: 'add',
              name: 'discountAdd',
              component: discountAdd,
              meta:{title:'新增优惠',isShowBack:true,isShowBread:true,matchLeftKey:'/discount/add'}
            },
          ]
        },
        {
          path: '/business',
          name: 'business',
          component: business,
          meta:{title:'商家管理'},
          children:[
            {
              path: 'list',
              name: 'businessList',
              component: businessList,
              meta:{title:'商家列表',isShowBread:true,matchLeftKey:'/business/list'}
            },
            {
              path: 'detail/:id',
              name: 'businessDetail',
              component: businessDetail,
              meta:{title:'商家详情',isShowBack:true,isShowBread:true,matchLeftKey:'/business/detail'}
            },
            {
              path: 'edit/:id',
              name: 'businessEdit',
              component: businessEdit,
              meta:{title:'商家编辑',isShowBack:true,isShowBread:true,matchLeftKey:'/business/edit'}
            },

            {
              path: 'add',
              name: 'businessAdd',
              component: businessAdd,
              meta:{title:'商家新增',isShowBack:true,isShowBread:true,matchLeftKey:'/business/add'}
            },
          ]
        },
        {
          path: '/goods',
          name: 'goods',
          component: goods,
          meta:{title:'商品管理'},
          children:[
            {
              path: 'list',
              name: 'goodsList',
              component: goodsList,
              meta:{title:'商品列表',isShowBread:true,matchLeftKey:'/goods/list'}
            },
            {
              path: 'detail/:id',
              name: 'goodsDetail',
              component: goodsDetail,
              meta:{title:'商品详情',isShowBack:true,isShowBread:true,matchLeftKey:'/goods/detail'}
            },
            {
              path: 'edit/:id',
              name: 'goodsEdit',
              component: goodsEdit,
              meta:{title:'商家编辑',isShowBack:true,isShowBread:true,matchLeftKey:'/goods/edit'}
            },

            {
              path: 'add/:id',
              name: 'goodsAdd',
              component: goodsAdd,
              meta:{title:'商品新增',isShowBack:true,isShowBread:true,matchLeftKey:'/goods/add'}
            },
          ]
        },
        {
          path: '/park',
          name: 'park',
          component: park,
          meta:{title:'园区管理'},
          children:[
            {
              path: 'list',
              name: 'parkList',
              component: parkList,
              meta:{title:'园区列表',isShowBread:true,matchLeftKey:'/park/list'}
            },
            {
              path: 'detail/:parkId',
              name: 'parkDetail',
              component: parkDetail,
              meta:{title:'园区详情',isShowBack:true,isShowBread:true,matchLeftKey:'/park/detail'}
            },
            {
              path: 'add',
              name: 'parkAdd',
              component: parkAdd,
              meta:{title:'园区新增',isShowBack:true,isShowBread:true,matchLeftKey:'/park/add'}
            },
            {
              path: 'edit/:parkId',
              name: 'parkEdit',
              component: parkEdit,
              meta:{title:'园区编辑',isShowBack:true,isShowBread:true,matchLeftKey:'/park/edit'}
            },
          ]
        },

        //公共
        {
            path: '/editPwd',
            name: 'editPwd',
            component: editPwd
        },
        //系统管理
        {
          path:'/system',
          name:'system',
          component:system,
          meta:{title:"系统管理"},
          children:[
            {
                path: 'leftMenuManager',
                name: 'leftMenuManager',
                component: leftMenuManager,
                meta:{title:'菜单管理',isShowBread:true,matchLeftKey:'/system/leftMenuManager'}
            },
             {
                path: 'userManager',
                name: 'userManager',
                component: userManager,
                meta:{title:'用户管理',isShowBread:true,matchLeftKey:'/system/userManager'}
            },
            {
                path: 'roleManager',
                name: 'roleManager',
                component: roleManager,
                meta:{title:'角色管理',isShowBread:true,matchLeftKey:'/system/roleManager'}
            },
            {
                path: 'functionManager',
                name: 'functionManager',
                component: functionManager,
                meta:{title:'功能配置',isShowBread:true,matchLeftKey:'/system/functionManager'}
            }
          ]

        }

      ]
    },
    // {
    //     path: '*',
    //     redirect: '/404'
    // },

  ]
})
function getCookie(cname)
{
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++)
  {
    var c = ca[i].trim();
    if (c.indexOf(name)==0) return c.substring(name.length,c.length);
  }
  return "";
}
router.beforeEach((to, from, next) => {
if(window.gtag){
  gtag('config', 'G-GE6PF8PP1X', {'page_path': to.fullPath})
}
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = "乔司时尚地图管理平台"
    }
    next();
})
router.afterEach((to, from) => {
    function restartLogin() {
        Message({
            message: "请先登录~",
            type: 'warning',
            duration: 500
        });
        setTimeout(function() {
            router.replace("/login")
        }, 500)
    }
    // console.log(to, from)
    let isLogined = getCookie("isLoginedAdmin_Qs")
    console.log("isLogined:"+isLogined)
    if (to.name != 'login' && isLogined != 'y') {
        restartLogin()
    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js